module.exports = __webpack_public_path__ + "img/sbh3.8d352fe9.jpg";